<app-modal-generico [modelo]="modalGenerico">
  <header class="text-center mb-3">
    <label class="h5">Enlazar preguntas</label>
  </header>
  <div class="form-group px-3">
    <label class="small text-secondary" for="">
      Seleccione las preguntas a enlazar a la pregunta "{{this.infoPregunta.descripcion}}"</label>
    <div class="input-group">
      <span class="input-group-text bg-white border-right-0">
        <img src="../../../../../../../assets/icons/Search Purple@2x.png" height="13" width="13" />
      </span>
      <input class="form-control form-control-sm border-left-0" id="filtroString" value="{{filtroString}}" style="border-top-right-radius: 0px; border-bottom-right-radius: 0px;"
        (input)="filtrar($event.target.value)">
    </div>

  </div>
  <div class="preguntas-container">
    <div *ngFor="let option of filtro; let i = index" class="form-check">
      <input [checked]="option?.value" (change)="seleccionPregunta(option?.id)" type="checkbox" class="form-check-input"
        id="pregunta-{{i}}">
      <label class="form-check-label" for="pregunta-{{i}}">{{ option?.name }}</label>
    </div>
  </div>
  <div class="form-row p-4">
    <button (click)="dismiss()" class="btn btn-outline-primary border-0 ml-auto">
      Cancelar
    </button>
    <button (click)="close()" class="btn btn-primary">
      Guardar</button>
  </div>
</app-modal-generico>
